"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderNextDeliveryHours = exports.getOrderResumableDate = exports.getOrderDeliveryDate = void 0;
var DateFormat_1 = require("../Dates/DateFormat");
var DateCheck_1 = require("../Dates/DateCheck");
var getOrderDeliveryDate = function (order) {
    var _a;
    return ((_a = order === null || order === void 0 ? void 0 : order.timeSlot) === null || _a === void 0 ? void 0 : _a.date)
        ? (0, DateFormat_1.tmsToFormat)(order.timeSlot.date, 'iiii dd MMMM')
        : undefined;
};
exports.getOrderDeliveryDate = getOrderDeliveryDate;
var getOrderResumableDate = function (order) {
    return (order === null || order === void 0 ? void 0 : order.limitDate)
        ? (0, DateFormat_1.tmsToFormat)(order.limitDate, 'iiii dd MMMM, HH\'h\'mm')
        : undefined;
};
exports.getOrderResumableDate = getOrderResumableDate;
var getOrderNextDeliveryHours = function (order) {
    var _a;
    var ts = (_a = order === null || order === void 0 ? void 0 : order.groupDeliveryDay) === null || _a === void 0 ? void 0 : _a.timeSlot;
    if (!ts || (0, DateCheck_1.isNextPotagerWeek)(ts.date))
        return undefined;
    return "D\u00E8s ".concat((0, DateFormat_1.tmsToFormat)(ts.startHour, 'HH\'h\'mm'), " jusqu'\u00E0 ").concat((0, DateFormat_1.tmsToFormat)(ts.endHour, 'HH\'h\'mm'));
};
exports.getOrderNextDeliveryHours = getOrderNextDeliveryHours;
exports.default = { getOrderDeliveryDate: exports.getOrderDeliveryDate, getOrderResumableDate: exports.getOrderResumableDate, getOrderNextDeliveryHours: exports.getOrderNextDeliveryHours };
//# sourceMappingURL=OrderDate.js.map